import {
  Component,
  EventEmitter,
  forwardRef,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';

@Component({
 standalone: false,
  selector: 'mx-input-switch',
  templateUrl: './mx.input-switch.component.html',
  styleUrls: ['./mx.input-switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MxInputSwitchComponent),
      multi: true,
    },
  ],
})
export class MxInputSwitchComponent
  extends MxBaseComponent
  implements ControlValueAccessor
{
  /**
   * Identifier of the input element.
   */
  @HostBinding('attr.id')
  externalId = '';

  @Input()
  set id(value: string) {
    this._id = value;
    this.externalId = null;
  }

  get id() {
    return this._id;
  }

  private _id = '';

  /**
   * Name of the input element.
   */
  @HostBinding('attr.name')
  externalName = '';

  @Input()
  set name(value: string) {
    this._name = value;
    this.externalName = null;
  }

  get inputName() {
    return this._name;
  }

  private _name = '';

  /**
   * Index of the element in tabbing order.
   */
  @HostBinding('attr.tabindex')
  externalTabindex = '';

  @Input()
  set tabindex(value: number) {
    this._tabindex = value;
    this.externalTabindex = null;
  }

  get tabindex() {
    return this._tabindex;
  }

  private _tabindex: number = null;

  /**
   * Value of the input element.
   */
  @Input('value') _value = false;
  onChange: any = () => {};
  onTouched: any = () => {};

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  /**
   * Component is visible
   */
  @Input() visible: boolean = true;

  /**
   * Inline style of the component.
   */
  @Input() style: { [klass: string]: any } | null = null;

  /**
   * Style class of the component.
   */
  @Input() styleClass: string;

  /**
   * When present, it specifies that the element should be disabled.
   */
  @Input() disabled: boolean = false;

  /**
   * When present, it specifies that the component cannot be edited.
   */
  @Input() readonly: boolean = false;

  /**
   * Value in checked state.
   */
  @Input() trueValue: any = true;

  /**
   * Value in unchecked state.
   */
  @Input() falseValue: any = false;

  /**
   * Callback to invoke on state change.
   */
  @Output() mxOnChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    super();
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(value: any) {
    this.value = value ?? null;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  mxChange(event: any) {
    this.mxOnChange.emit(event);
  }
}

